import { dispose } from './dispose';
import { playNote } from './playNote';
import { setVoice } from './setVoice';

export const instrument = {
  dispose,
  playNote,
  setVoice,
};
